const eh_triagem = process.env.REACT_APP_CONAZ_PROJECT === 'construtor-interno';

export const EXIBIR_LABEL_CADASTRADO_POR_INTERNO = eh_triagem;
export const EXIBIR_LABEL_CADASTRADO_POR_CLIENTE = !eh_triagem;
export const INCLUIR_CADASTRADO_POR_NA_BUSCA = !eh_triagem;
